<template>
    <div class="flex_container" v-loading="loading">
        <div class="carousel">
            <CarouselPage :imagList="imagList" />
        </div>

        <div class="view_container">
            <Section title="产品中心">
                <p>以客户需求和产品发展理念为驱动力</p>
                <ProductCenter />
            </Section>

            <Section title="智慧农业解决方案">
                <div :class="['move_com', { active: isActive }]">
                    <Solutions :isShow="false" />
                </div>
            </Section>


            <div>
                <ProjectCase :isShow="false" />
            </div>

            <Section title="公司资质">
                <p>我们在传承中发展，在感恩中前行</p>
                <CompanyQualification />
            </Section>
        </div>

        <div>
            <ContactFooter />
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import CarouselPage from '../components/carouselPage.vue';
import ProductCenter from '../pages/components/pageCenter.vue';
import Section from '../components/Section.vue';
import CompanyQualification from './components/companyQualification.vue';
import ContactFooter from '../components/contactFooter.vue';
import { getContentList } from '@/utils/api';
import ProjectCase from './projectCase.vue';
import Solutions from './solutions.vue';
import { useStore } from '@/store/index';
const store = useStore();
const isActive = ref(false);
const moveCom = ref(null);

const imagList = ref([]);
const loading = ref(false)

const observerCallback = (entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            isActive.value = true;
            observer.unobserve(entry.target);
        }
    });
};

let observer;

onMounted(() => {
    localStorage.setItem('previousRoute', '首页')
    observer = new IntersectionObserver(observerCallback, { threshold: 0.1 });
    const moveComElement = document.querySelector('.move_com');
    if (moveComElement) observer.observe(moveComElement);
    fetchData();
});

const fetchData = async () => {
    await fetchBannerData();
};

const fetchBannerData = async () => {
    loading.value = true
    const _bannerData = store.allData['/']
    const _bannerImage = _bannerData?.find(v => v.contentType === 'banner')?.contentImg;
    imagList.value = _bannerImage || []
    loading.value = false
};

</script>

<style lang="less" scoped>
.flex_container {
    width: 100%;
    // width: calc(1190* var(--groot-ui-rpx));
    margin: 0 auto;
    overflow: hidden;
}

.carousel {
    width: 100%;
    margin: calc(10 * var(--groot-ui-rpx)) auto;
}

.cards {
    width: 100%;
    overflow: hidden;
}

.move_com {
    width: 100%;
    position: relative;
    right: calc(-400 * var(--groot-ui-rpx));
    transition: right 0.5s ease;
    overflow: hidden;
}

.move_com.active {
    right: 0;
}

/deep/ .el-button:hover {
    background-color: #126324;
    color: #fff;
}

p {
    font-size: calc(16 * var(--groot-ui-rpx));
    margin: calc(15 * var(--groot-ui-rpx)) 0 calc(30 * var(--groot-ui-rpx));
    color: #999999 !important;
}

.view_container {
    width: calc(1190* var(--groot-ui-rpx));
    margin: 0 auto;
}

@media (max-width: 768px) {
    .move_com {
        right: 0;
    }

    .view_container {
        width: 100%;
    }
}
</style>
